/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description favoritesView selector
 */

import { memoizeState } from '@zcode/memoizers'
import uniqueListables from '@zcode/nr/es/shared/utils/uniqueListables'
import type { State } from '@zcode/state-type'
import { compose } from 'redux'

const selectFavoritesView = (state: State) => state.favoritesView
const selectListablesRecord = (state: State) => state.favoritesView.listables

export const selectHasListables = (state: State) => {
  const listables = selectListables(state)
  return !!listables.length
}

export const selectIsLoadingListables = compose(
  (state) => state.fetchingListables,
  selectFavoritesView
)

export const selectListables = compose(
  memoizeState((state) => uniqueListables(state.listables)),
  selectListablesRecord
)

export const selectMatching = compose((state) => state.matching, selectListablesRecord)
